import React from 'react';
import { Store, Building, Landmark, CircleDollarSign, Globe2 } from 'lucide-react';
import { clientTypes } from '../data/mock';

const iconMap = {
  Store,
  Building,
  Landmark,
  CircleDollarSign,
  Globe2,
};

const ClientsSection = () => {
  return (
    <section className="py-24 bg-charcoal">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-12 h-0.5 bg-gold" />
            <span className="text-gold text-sm tracking-widest uppercase font-medium">
              Our Partners
            </span>
            <div className="w-12 h-0.5 bg-gold" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-ivory mb-6">
            Who We Work With
          </h2>
          <p className="text-slate text-lg max-w-2xl mx-auto">
            We collaborate with diverse stakeholders across the investment and
            development ecosystem.
          </p>
        </div>

        {/* Client Types Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {clientTypes.map((client) => {
            const IconComponent = iconMap[client.icon];
            return (
              <div
                key={client.id}
                className="group p-6 bg-charcoal border border-slate/20 hover:border-gold/50 transition-all duration-500 text-center"
              >
                <div className="w-16 h-16 bg-burgundy/10 flex items-center justify-center mx-auto mb-4 group-hover:bg-burgundy transition-colors duration-300">
                  {IconComponent && (
                    <IconComponent
                      className="text-gold group-hover:text-ivory transition-colors duration-300"
                      size={28}
                    />
                  )}
                </div>
                <p className="text-ivory text-sm font-medium leading-snug">
                  {client.name}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
